import { getSize } from '../iterable/getSize';

import { SELECTION } from '../../constants/listings';
import { EMPTY } from '../../constants';

export function setSelection({ products }) {
  if (getSize(products.get('selected')) === 0) return products.delete('selection');

  const all = products.get('all', EMPTY.LIST).toSet();
  const selected = products.get('selected', EMPTY.ORDERED_SET).toSet();
  const total = products.get('total');

  if (getSize(selected) === total || selected.equals(all)) {
    return products.set('selection', SELECTION.ALL);
  }

  const page = products.get('ids').toSet();

  if (getSize(selected) >= getSize(page) && page.intersect(selected).equals(page)) {
    return products.set('selection', SELECTION.PAGE);
  }

  return products.delete('selection');
}
